"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jss_1 = require("./jss");
const staticClassNames = {};
function generateStaticClassName(key) {
    // if the key is not a string, its a component
    if (!(typeof key === 'string')) {
        key = key.displayName || key.name;
    }
    // the key has to exist, it cannot be auto-magically derived
    if (!key) {
        // eslint-disable-next-line no-console
        console.warn('domonda-ui: cannot generate static class name for anonymous functions or empty keys');
    }
    // look if the static class name is already generated, if not, generate it
    if (!staticClassNames[key]) {
        // NOTE: `generateId` does indeed exist in the JSS instance
        staticClassNames[key] = jss_1.jss.generateId({ key });
    }
    return staticClassNames[key];
}
exports.generateStaticClassName = generateStaticClassName;
